import { MainContents } from '@/components/MainContents';
import ProvidedJobPostsForm from '@/features/agent/provided_job_posts/components/ProvidedJobPostsForm';

type Props = {
  title?: string;
  jobContent?: Array<{
    key: string;
    content?: string;
  }>;
  workingLocation?: string;
  jobPositionName?: string;
  minSalary?: number;
  maxSalary?: number;
};

export function TextImportCompletedStatus({
  title,
  jobContent,
  workingLocation,
  jobPositionName,
  minSalary,
  maxSalary,
}: Props) {
  const initialData = {
    title: title || '',
    jobContentJson: jobContent || [],
    workingLocation,
    jobPositionName,
    minSalary,
    maxSalary,
  };

  return (
    <MainContents>
      <div className="flex min-h-screen flex-col bg-white">
        <section className="p-6 pt-3">
          <ProvidedJobPostsForm formType="create" initialData={initialData} />
        </section>
      </div>
    </MainContents>
  );
}
